import apiClient from './apiClient';

export async function startBqMockSession({ questionCount = 3, mode = 'QUICK' } = {}) {
  const { data } = await apiClient.post('/bq/mock/sessions', { questionCount, mode });
  return data;
}

export async function listBqMockSessions() {
  const { data } = await apiClient.get('/bq/mock/sessions');
  return data;
}

export async function getBqMockSession(sessionId) {
  const { data } = await apiClient.get(`/bq/mock/sessions/${sessionId}`);
  return data;
}

export async function submitBqMockAnswer(sessionId, answerId, answerText, answerDurationSeconds) {
  const body = { answerText };
  if (answerDurationSeconds != null) {
    body.answerDurationSeconds = answerDurationSeconds;
  }
  const { data } = await apiClient.post(`/bq/mock/sessions/${sessionId}/answers/${answerId}`, body);
  return data;
}

export async function completeBqMockSession(sessionId) {
  const { data } = await apiClient.post(`/bq/mock/sessions/${sessionId}/complete`);
  return data;
}

export async function transcribeBqMockAudio(audioBlob, filename = 'recording.webm', sessionId, answerId) {
  const form = new FormData();
  form.append('file', audioBlob, filename);
  const params = {};
  if (sessionId != null) params.sessionId = sessionId;
  if (answerId != null) params.answerId = answerId;
  const { data } = await apiClient.post('/bq/mock/transcribe', form, { params });
  return data;
}
